import { useModals } from "web/hooks/modals"
import { LockedFieldForm } from "web/components"

import { promoteKey } from "web/services/helpers"

import { fieldIsVisible } from "web/components/Form/helpers"
import { plainObjectFromValue } from "web/services/helpers"

export default function useLockedFieldEdit() {
  const { showModal } = useModals()

  return async function (fieldKey, field, rowData, globalValue) {
    const fieldValue = rowData.values[fieldKey]

    if (globalValue === null) {
      globalValue = promoteKey(rowData.values, "value")
    }
    const dataForConditions = plainObjectFromValue(globalValue)

    if (fieldIsVisible(field, dataForConditions)) {
      return showModal({
        title: `Edit Locked Field: ${field.label}`,
        fullScreen: false,
        widthPixels: 500,
        heightPixels: 500,
        message: "Updating field. Please wait",
        component: ({ close }) => (
          <LockedFieldForm
            fieldKey={fieldKey}
            field={field}
            fieldValue={fieldValue}
            rowData={rowData}
            closeModal={close}
            globalValue={globalValue}
          />
        ),
      })
    }
  }
}
